import Swiper from 'swiper/bundle';
import 'swiper/css';
import './animated-text';

jQuery(document).ready(function($){

    $('.menu-toggler').on('click', function(e){
        e.preventDefault();

        var $menu = $(this).siblings('.mobile-menu-container');
        $(this).toggleClass('toggled');
        $('header').toggleClass('mobile-menu-toggled');
        $menu.slideToggle(300);

        $('body').toggleClass('menu-open-fixed');
    });


    $('.submenu-toggle').on('click', function(e){
        e.preventDefault();

        var $menu = $(this).siblings('ul');
        $(this).toggleClass('toggled');
        $(this).closest('li').toggleClass('toggled');

        $menu.slideToggle(300);

    });


    $('.mobile-menu-container .polylang-switcher').on('click', function(e){
        e.preventDefault();

        var $menu = $(this).find('ul');
        $(this).toggleClass('toggled');

        $menu.slideToggle(300);

    });



    const carousels = document.querySelectorAll(".theme-carousel .carousel-container");

    carousels.forEach((carousel) => {
        const parent = carousel.closest(".theme-carousel");
        const nextEl = parent.querySelector(".carousel-navigation .carousel-ar.next");
        const prevEl = parent.querySelector(".carousel-navigation .carousel-ar.prev");


        new Swiper(carousel, {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: ".theme-carousel .carousel-ar.next",
                prevEl: ".theme-carousel .carousel-ar.prev",
            },
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },
            touchAngle: 20,
            threshold: 15,
            breakpoints: {
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 4, spaceBetween: 24 },
            },
        });
    });



    $('.accordion-item .wrapper-title').click(function(){
        $(this).closest('.accordion-item').toggleClass('toggled');
        $(this).siblings('.wrapper-content').slideToggle(400);
    });



    (function () {
        const parent = document.querySelector('.elementor-widget-theme-post-content');
        const tocList = document.querySelector('.theme-table-of-contents');
        if (!parent || !tocList) return;

        const headings = parent.querySelectorAll('h2');
        if (!headings.length) return;

        function slugify(text) {
            return String(text).toLowerCase().trim()
                .replace(/\s+/g, '-')
                .replace(/[^\w\-]/g, '')
                .replace(/\-+/g, '-')
                .replace(/^-+|-+$/g, '');
        }

        tocList.innerHTML = '';
        const used = new Set();

        headings.forEach((h, idx) => {
            let base = h.id ? h.id : slugify(h.textContent || ('section-'+(idx+1)));
            if (!base) base = 'section-' + (idx+1);
            let id = base;
            let i = 1;
            while (used.has(id) || document.getElementById(id)) {
                id = base + '-' + i;
                i++;
            }
            used.add(id);
            h.id = id;

            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + id;
            a.textContent = h.textContent.trim();
            li.appendChild(a);
            tocList.appendChild(li);
        });

        function updateActive() {
            const hash = location.hash ? location.hash.slice(1) : '';
            tocList.querySelectorAll('a').forEach(a => {
                a.classList.toggle('active', a.getAttribute('href') === '#' + hash);
            });
        }
        window.addEventListener('hashchange', updateActive);
        updateActive();
    })();


    jQuery(document).on('click', '.load-more-btn', function () {
        let button = jQuery(this);
        let wrapper = button.closest('.theme-posts');
        let page = parseInt(button.attr('data-page')) + 1;
        let maxPages = parseInt(wrapper.attr('data-max-pages'));
        let postType = wrapper.attr('data-post-type');
        let buttonText = button.text();
        jQuery.ajax({
            url: ripplr_ajax.ajaxurl,
            type: 'POST',
            data: {
                action: 'ripplr_load_more',
                page: page,
                post_type: postType
            },
            beforeSend: function () {
                button.html('<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_1KD7{animation:spinner_6QnB 1.2s infinite}.spinner_MJg4{animation-delay:.1s}.spinner_sj9X{animation-delay:.2s}.spinner_WwCl{animation-delay:.3s}.spinner_vy2J{animation-delay:.4s}.spinner_os1F{animation-delay:.5s}.spinner_l1Tw{animation-delay:.6s}.spinner_WNEg{animation-delay:.7s}.spinner_kugV{animation-delay:.8s}.spinner_4zOl{animation-delay:.9s}.spinner_7he2{animation-delay:1s}.spinner_SeO7{animation-delay:1.1s}@keyframes spinner_6QnB{0%,50%{animation-timing-function:cubic-bezier(0.27,.42,.37,.99);r:0}25%{animation-timing-function:cubic-bezier(0.53,0,.61,.73);r:2px}}</style><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>');
            },
            success: function (res) {
                if (res) {
                    wrapper.find('.posts-container').append(res);
                    button.attr('data-page', page).text(buttonText);
                    if (page >= maxPages) {
                        button.remove();
                    }
                } else {
                    button.remove();
                }
            }
        });
    });


    jQuery(document).on('click', '.guides-cat-btn', function () {
        let btn = jQuery(this);
        let w = btn.closest('.guides-categories-widget');
        let mode = w.attr('data-mode');
        let archiveUrl = w.attr('data-archive');
        let term = btn.attr('data-term') || '';

        w.find('.guides-cat-btn').removeClass('is-active');
        btn.addClass('is-active');

        if (mode === 'single') {
            let url = new URL(archiveUrl, window.location.origin);
            if (term) url.searchParams.set('cat', term);
            else url.searchParams.delete('cat');
            window.location.href = url.toString();
            return;
        }

        let url = new URL(window.location.href);
        if (term) url.searchParams.set('cat', term);
        else url.searchParams.delete('cat');
        window.history.replaceState({}, '', url.toString());

        let guidesWidget = jQuery('.guides-widget').first();
        let container = guidesWidget.find('.guides-container');
        let loadWrap = guidesWidget.find('.load-more-wrap');
        let loadBtn = guidesWidget.find('.load-more-btn-guides');

        let perPage = loadBtn.length ? parseInt(loadBtn.attr('data-per-page'), 10) : 10;
        if (!perPage) perPage = 10;

        jQuery.ajax({
            url: ripplr_ajax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ripplr_guides_query',
                page: 1,
                per_page: perPage,
                term: term,
                prev_bg: '',
                offset: 0
            },
            beforeSend: function () {
                if (loadBtn.length) loadBtn.prop('disabled', true);
            },
            success: function (res) {
                if (!res || !res.success) return;

                let html = res.data.html || '';
                let maxPages = parseInt(res.data.max_pages || 1, 10);

                container.html(html);

                guidesWidget.attr('data-term', term);

                if (loadBtn.length) {
                    loadBtn.prop('disabled', false);
                    loadBtn.attr('data-page', 1);
                    loadBtn.attr('data-max', maxPages);
                }

                if (loadWrap.length) {
                    if (maxPages > 1) loadWrap.show();
                    else loadWrap.hide();
                }
            },
            error: function () {
                if (loadBtn.length) loadBtn.prop('disabled', false);
            }
        });
    });
    jQuery(document).on('click', '.guides-widget .load-more-btn-guides', function () {
        let button = jQuery(this);
        let guidesWidget = button.closest('.guides-widget');
        let container = guidesWidget.find('.guides-container');
        let wrap = button.closest('.load-more-wrap');

        let perPage = parseInt(button.attr('data-per-page'), 9);
        if (!perPage) perPage = 9;

        let term = guidesWidget.attr('data-term') || '';

        let lastItem = container.find('.guide-item').last();
        let prevBg = lastItem.length ? (lastItem.attr('data-bg') || '') : '';

        let offset = container.find('.guide-item').length;

        let pageUi = parseInt(button.attr('data-page'), 9);
        if (!pageUi) pageUi = 1;

        button.addClass('is-loading').prop('disabled', true);

        jQuery.ajax({
            url: ripplr_ajax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ripplr_guides_query',
                per_page: perPage,
                term: term,
                prev_bg: prevBg,
                offset: offset
            },
            success: function (res) {
                if (res && res.success && res.data && res.data.html) {
                    container.append(res.data.html);

                    let nextPageUi = pageUi + 1;
                    button.attr('data-page', nextPageUi);

                    if (res.data.max_pages) {
                        button.attr('data-max', parseInt(res.data.max_pages, 9));
                    }

                    if (res.data.has_more === false) {
                        if (wrap.length) wrap.hide();
                    } else {
                        if (wrap.length) wrap.show();
                    }
                } else {
                    if (wrap.length) wrap.hide();
                }
            },
            complete: function () {
                button.removeClass('is-loading').prop('disabled', false);
            }
        });
    });







});
